import React from "react";
import { Link } from "react-router-dom";
import { ChefHat, BarChart3, MessageSquare, ListOrdered, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function RestaurantLandingPage() {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b bg-card">
        <div className="max-w-6xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between">
          <Link to="/" className="font-serif text-2xl font-bold text-primary" data-testid="rp-landing-logo">
            Cravve
          </Link>
          <div className="flex gap-2">
            <Link to="/restaurant-portal/signin">
              <Button variant="ghost" size="sm" data-testid="rp-landing-signin">Sign in</Button>
            </Link>
            <Link to="/restaurant-portal/signup">
              <Button size="sm" className="font-semibold" data-testid="rp-landing-signup">Register restaurant</Button>
            </Link>
          </div>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-4 md:px-6 py-12 md:py-20">
        <div className="text-center max-w-2xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-semibold mb-6">
            <ChefHat className="w-4 h-4" /> Restaurants on Cravve
          </div>
          <h1 className="font-serif text-4xl md:text-6xl font-bold leading-tight">
            Reach customers <span className="text-primary">craving</span> your food.
          </h1>
          <p className="text-lg text-muted-foreground mt-6 max-w-xl mx-auto">
            Join Cravve and let our AI assistant recommend your dishes to thousands of hungry Ghanaians and Nigerians.
            Manage your menu, profile and orders from one simple dashboard.
          </p>
          <div className="flex flex-wrap justify-center gap-3 mt-8">
            <Link to="/restaurant-portal/signup">
              <Button className="h-12 px-6 text-base font-semibold gap-2" data-testid="rp-landing-cta-primary">
                Register your restaurant <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
            <Link to="/restaurant-portal/signin">
              <Button variant="outline" className="h-12 px-6 text-base font-semibold" data-testid="rp-landing-cta-secondary">
                Restaurant sign in
              </Button>
            </Link>
          </div>
        </div>

        <div className="grid sm:grid-cols-3 gap-4 mt-16 max-w-4xl mx-auto">
          {[
            { icon: MessageSquare, title: "AI recommends you", body: "Our chat assistant surfaces your dishes when customers describe what they're craving." },
            { icon: ListOrdered, title: "Easy menu manager", body: "Add categories, photos, prices and toggle availability in seconds." },
            { icon: BarChart3, title: "Live orders", body: "See every order the moment it comes in, all in one view." },
          ].map((f) => (
            <div key={f.title} className="bg-card border rounded-2xl p-5">
              <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center mb-3">
                <f.icon className="w-5 h-5 text-primary" />
              </div>
              <p className="font-serif font-bold text-lg">{f.title}</p>
              <p className="text-sm text-muted-foreground mt-1">{f.body}</p>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
